<template>
  <div class="width-100 min-height" id="body-div" style="padding: 20px 5%">
    <div class="flex-row align-items-center justify-content-spaceBetween padding-lr-15 br-reg" style="background: #f7f7f7">
      <van-field
        style="width: 80%; background: #f7f7f7; padding-left: 0; padding-right: 0"
        placeholder="请输入奖品名称搜索"
        v-model="searchObj.name"
        @keyup.enter="onRefresh"
      />
      <div class="width-20 fs-mid-sml line-height white textAlign-c br-reg" style="background: #1e67f7" @click="onRefresh">
        <van-icon name="search" />搜索
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="width-100 height-100 margin-t15">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length == 0 ? '' : '没有更多了'"
        @load="onLoad"
        class="width-100 height-100"
      >
        <div
          class="width-100 border bg-white flex-column align-items-center justify-content-spaceBetween br-reg overflow-h margin-b position-relative"
          style="padding: 10px 5%"
          v-for="(item, key) in list"
          :key="key"
        >
          <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
            <div class="fs-mid-sml">手机号：{{ item.phone_hide.slice(0, 3) + '****' + item.phone_hide.slice(7) }}</div>
            <div class="fs-mid-sml" style="color: #ffb101">待使用</div>
          </div>
          <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts">
            <van-image :src="item.picture_url" width="25%" height="3.5rem" fit="contain" />
            <div class="flex-column align-items-center justify-content-spaceBetween" style="height: 3.5rem; width: 73%">
              <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
                {{ item.name }}
              </div>
              <div class="width-100 fs-sml red">将于{{ item.failure_time }}过期</div>
            </div>
          </div>
          <div @click="phoneCall(item.phone)" class="position-absolute white fs-sml textAlign-c" style="bottom: -2px; right: 0">
            <van-image :src="require('../../assets/image/shop/lxkh.png')" width="4.5rem" />
          </div>
        </div>
        <van-empty v-if="emptyShow" description="暂无核销记录" />
      </van-list>
    </van-pull-refresh>
    <van-calendar :min-date="new Date('2023/01/01')" :max-date="new Date()" v-model="show" type="range" @confirm="onConfirm" />
  </div>
</template>
  
  <script>
import { Toast } from 'vant';
import { get_verified_record } from '@/api/shop';
export default {
  data() {
    return {
      show: false,
      emptyShow: false,
      refreshing: false,
      bodyWidth: '',
      list: [],
      loading: false,
      finished: false,
      searchObj: {
        pageNum: 0,
        pageSize: 10,
        begin_date: '',
        end_date: '',
        begin_date2: '',
        end_date2: '',
        name: ''
      }
    };
  },
  beforeMount() {
    this.$nextTick(() => {
      this.bodyWidth = document.getElementById('body-div').clientWidth;
    });
    let time = new Date();
    this.searchObj.begin_date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-01';
    this.searchObj.end_date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
    this.searchObj.begin_date2 = time.getFullYear() + '年' + (time.getMonth() + 1) + '月1日';
    this.searchObj.end_date2 = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
  },
  methods: {
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getDeptLists();
    },
    getDeptLists() {
      get_verified_record({
        page: this.searchObj.pageNum,
        begin_date: this.searchObj.begin_date,
        end_date: this.searchObj.end_date,
        name: this.searchObj.name
      }).then((res) => {
        if (res.code == 0) {
          this.list = this.list.concat(res.data);
          let list = this.list.concat(res.data);
          if (res.data.length == 0) {
            this.finished = true;
          }
          if (list.length == 0) {
            this.emptyShow = true;
          }
        } else {
          Toast(res.msg);
          this.finished = true;
        }
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      this.list = [];
      this.searchObj.pageNum = 0;
      this.emptyShow = false;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onConfirm(e) {
      let time = new Date(e[0]);
      let time2 = new Date(e[1]);
      this.searchObj.begin_date = this.$dayjs(new Date(e[0])).format('YYYY-MM-DD');
      this.searchObj.end_date = this.$dayjs(new Date(e[1])).format('YYYY-MM-DD');
      this.searchObj.begin_date2 = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
      this.searchObj.end_date2 = time2.getFullYear() + '年' + (time2.getMonth() + 1) + '月' + time2.getDate() + '日';
      this.show = false;
      this.onRefresh();
    },
    phoneCall(e) {
      window.location.href = 'tel://' + e;
    }
  }
};
</script>
  
  <style scoped>
::v-deep .van-cell::after {
  border: unset;
}
</style>